<template>
  <v-container fill-height fluid style="background-color: #f5f5f5">
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md6 lg4 xl3 shrink>
        <v-slide-x-reverse-transition hide-on-leave>
          <v-form ref="loginForm" v-model="isVendorFormValid" autocomplete="off" v-show="isVendorFormShow">
            <v-card :loading="isLoading" >
              <!-- <v-card-title>
                <v-layout row align-center justify-center>
                  <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.logIn') }}</span>
                </v-layout>
              </v-card-title> -->
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-img :src="require('@/assets/logo2.png')" max-width="110px"></v-img>
                  </v-col>
                  <v-col cols="12">
                    <span class="text-h6">{{ $t('label.signIn') }}</span>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="login.vendorCode"
                      :rules="[rules.required(login.vendorCode, $t('rule.required.vendorCode')), rules.alphanumeric]"
                      name="vendorCode"
                      autocomplete="off"
                      :label="$t('label.enterVendorCode')"
                      :error-messages="errorMessage"
                      >
                      <!-- prepend-inner-icon="mdi-account-box" -->
                      <!-- :label="$t('label.vendorCode')" -->
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <span class="text-caption">{{ $t('label.vendorCodeInfo') }}</span>
                  </v-col>
                </v-row>
                <!-- <v-text-field
                  v-model="login.password"
                  :rules="[rules.required(login.password, $t('rule.required.password'))]"
                  :label="$t('label.password')"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye-off': 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" @keypress.enter="submit" name="password" outlined dense>
                </v-text-field> -->
                <!-- <a @click.stop="isForgotPasswordDialogOpen = true">{{ $t('label.forgotPassword') }}</a> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn small color="primary" depressed :disabled="!isFormValid" @click="submit" :loading="isLoading">{{ $t('label.enter') }}</v-btn> -->
                <v-btn
                  color="primary"
                  depressed
                  tile
                  @click="nextForm"
                  type="submit"
                  :disabled="!login.vendorCode"
                  :loading="isLoading"
                  >
                  <!-- :disabled="!isVendorFormValid" -->
                  {{ $t('label.next') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-slide-x-reverse-transition>
        <v-slide-x-transition hide-on-leave>
          <v-form v-show="isPasswordFormShow" v-model="isFormValid" autocomplete="off">
            <v-card :loading="isLoading">
              <!-- <v-card-title>
                <v-layout row align-center justify-center>
                  <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.logIn') }}</span>
                </v-layout>
              </v-card-title> -->
              <v-card-text>
                <v-row align="center">
                  <v-col cols="12">
                    <v-img :src="require('@/assets/logo2.png')" max-width="110px"></v-img>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters align="center">
                      <v-col cols="1">
                        <v-btn
                          icon
                          @click="backForm"
                          :disabled="isLoading"
                          >
                          <v-icon>
                            mdi-arrow-left
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="11">
                        <span class="text-caption">{{ vendorName }}</span>
                      </v-col>
                      <v-col cols="12">
                        <span class="text-h6">{{ $t('label.enterPassword') }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col cols="1">
                    <v-btn
                      icon
                      @click="backForm"
                      :disabled="isLoading"
                      >
                      <v-icon>
                        mdi-arrow-left
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="11">
                    <span class="text-caption">{{ login.vendorCode }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="text-h6">Enter password</span>
                  </v-col> -->
                  <v-col cols="12">
                    <v-text-field
                      v-model="login.password"
                      :rules="[rules.required(login.password, $t('rule.required.password'))]"
                      :label="$t('label.password')"
                      :append-icon="showPassword ? 'mdi-eye-off': 'mdi-eye'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      @keypress.enter="submit" name="password"
                      >
                      <!-- prepend-inner-icon="mdi-lock" -->
                    </v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-text-field
                  v-model="login.vendorCode"
                  :rules="[rules.required(login.vendorCode, $t('rule.required.vendorCode'))]"
                  :label="$t('label.vendorCode')"
                  prepend-inner-icon="mdi-account-box"
                  name="vendorCode"
                  autocomplete="off"
                  outlined
                  dense>
                </v-text-field> -->
                <a @click.stop="isForgotPasswordDialogOpen = true">{{ $t('label.forgotPassword') }}</a>
              </v-card-text>
              <v-card-actions>
                <!-- <v-btn
                 small
                 color="primary"
                 depressed
                 @click="backForm"
                 :loading="isLoading"
                 >
                 {{ $t('label.back') }}
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn
                 color="primary"
                 depressed
                 tile
                 type="submit"
                 :disabled="!isFormValid"
                 @click="submit"
                 :loading="isLoading"
                 >
                 {{ $t('label.signIn') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-slide-x-transition>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isForgotPasswordDialogOpen" persistent max-width="700">
      <v-card :loading="isLoading" :disabled="isLoading">
        <v-card-title>
          <v-row justify="space-between">
            <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.resetPassword') }}</span>
            <v-btn icon @click.stop="isForgotPasswordDialogOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-form ref="resetPasswordForm" v-model="isResetPasswordFormValid" autocomplete="off">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="resetPassword.vendorCode"
                  :rules="[rules.required(resetPassword.vendorCode, $t('rule.required.vendorCode'))]"
                  :label="$t('label.vendorCode')"
                  name="vendorCode"
                  autocomplete="off"
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <p>
                  <strong>
                    {{ $t('message.info.resetPasswordText') }}
                  </strong>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small depressed @click.stop="isForgotPasswordDialogOpen = false" :disabled="isLoading">{{ $t('label.cancel') }}</v-btn>
            <v-btn small depressed @click.stop="requestPasswordReset" color="primary" :loading="isLoading" :disabled="!isResetPasswordFormValid">{{ $t('label.continue') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import { loading, showMessage, rules } from '../mixins'
import authService from '../helpers/authService'

export default {
  name: 'LoginPage',
  mixins: [loading, showMessage, rules],
  data: () => ({
    errorMessage: '',
    vendorName: '',
    isPasswordFormShow: false,
    isFormValid: null,
    isVendorFormValid: null,
    isResetPasswordFormValid: null,
    showPassword: false,
    login: {
      vendorCode: '',
      password: ''
    },
    isForgotPasswordDialogOpen: false,
    resetPassword: {
      vendorCode: ''
    }
  }),
  computed: {
    isVendorFormShow () {
      return !this.isPasswordFormShow
    }
  },
  methods: {
    backForm () {
      this.isPasswordFormShow = false
    },
    async nextForm (event) {
      event.preventDefault()
      try {
        this.changeLoadingStatus(true)
        this.errorMessage = ''
        const response = await this.$proxy.get(`api/vendors/${this.login.vendorCode}`)
        this.vendorName = response.data.name
        this.isPasswordFormShow = true
      } catch (_) {
        this.errorMessage = this.$t('label.vendorNotFound')
      } finally {
        this.changeLoadingStatus(false)
      }
    },
    submit (event) {
      event.preventDefault()
      this.changeLoadingStatus(true)
      authService.authenticate(this.login.vendorCode, this.login.password)
        .then((r) => {
          if (typeof this.$route.query.redirect !== 'undefined') {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push('/')
          }
        })
        .catch((e) => {
          if (typeof e.response === 'undefined') {
            this.showMessage(this.$t('message.error.generic'))
            return
          }
          let message = `${e.response.status}`
          if (e.response.status === 401) {
            message = this.$t('message.error.invalidCredentials')
          } else {
            message = this.$t('message.error.genericHttp', [message])
          }
          this.showMessage(message)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    requestPasswordReset () {
      this.changeLoadingStatus(true)
      this.$proxy.post(`api/vendors/requestpasswordreset/${this.resetPassword.vendorCode}`)
        .then((r) => {
          this.showMessage(this.$t('message.success.resetPasswordEmailSent'))
          this.isForgotPasswordDialogOpen = false
          this.resetPassword.vendorCode = ''
          this.$refs.resetPasswordForm.resetValidation()
        })
        .catch((e) => {
          if (e.response.status === 404) {
            this.showMessage(this.$t('message.error.invalidVendorCode'))
          } else {
            this.showHttpErrorMessage(e)
          }
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    }
  }
}
</script>

<style>

</style>
